const initialState = { data: [], loading: true };

export const GetAllGatepassReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_all_gatepass":
      return {
        data: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
